"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
const react_1 = __importDefault(require("react"));
const model_1 = require("./model");
const utils_1 = require("../../utils");
const jsonld_schema_1 = require("../jsonld-schema");
const Organization = ({ data }) => {
    const organization = (0, model_1.getOrganizationSchema)(data);
    const main = (0, utils_1.getBaseSchema)('Organization');
    const structure = { ...main, ...organization };
    if (structure) {
        return react_1.default.createElement(jsonld_schema_1.JsonldSchema, { structure: structure });
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Organization = Organization;
